import { DecimalPipe, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { HighlightSearchPipe } from '@pinnakl/shared/ui/directives-and-pipes';
import { SearchSecurityItem } from '../security-item.model';
import { addAlpha, getCurrentSymbol } from '../security-item.util';

@Component({
  selector: 'pnkl-security-item',
  templateUrl: './security-item.component.html',
  styleUrls: ['./security-item.component.scss'],
  imports: [NgStyle, HighlightSearchPipe, DecimalPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecurityItemComponent {
  getCurrentSymbol = getCurrentSymbol;
  addAlpha = addAlpha;
  readonly dataItem = input<SearchSecurityItem>(undefined);
  readonly searchText = input('');
  readonly itemSelected = output<SearchSecurityItem>();

  itemClickHandler(item: SearchSecurityItem): void {
    this.itemSelected.emit(item);
  }
}
